import { TaskableTypeEnum } from '@hefe/models';
import { Col, Menu, MenuProps, Row } from 'antd';
import { useMemo, useState } from 'react';
import TaskAssignmentComponent from '../task-assignment/task-assignment.component';
import styles from './tasks-assignments.component.module.scss';

type MenuItem = Required<MenuProps>['items'][number];

interface TasksAssignmentsComponentProps {
  type: TaskableTypeEnum;
  items: MenuItem[];
}

export default function TasksAssignmentsComponent(
  props: TasksAssignmentsComponentProps
) {
  const [activeMenuKey, setActiveMenuKey] = useState('');

  /**
   * Add className to each item
   */
  const items = useMemo(() => {
    const addClassName = (items: any[]) => {
      items.forEach((item) => {
        if (item) {
          item.className = styles['menu-item'];
          if (item.children) {
            addClassName(item.children);
          }
        }
      });
    };

    const returnValue = [...props.items];
    addClassName(returnValue);

    return returnValue;
  }, [props.items]);

  return (
    <div>
      <Row>
        <Col xs={24} md={8} lg={6}>
          <Menu
            mode="inline"
            onClick={(e) => setActiveMenuKey(e.key)}
            defaultSelectedKeys={[]}
            defaultOpenKeys={['club', 'team']}
            items={items}
            style={{ color: 'black' }}
          />
        </Col>
        <Col xs={24} md={16} lg={18} style={{ paddingLeft: 12 }}>
          <TaskAssignmentComponent taskId={activeMenuKey} type={props.type} />
        </Col>
      </Row>
    </div>
  );
}
